module.exports = __webpack_public_path__ + "img/404.4ea780b6.png";